import {
  Box,
  Modal,
  Autocomplete,
  TextField,
  Paper,
  useMediaQuery,
} from "@mui/material";
import { useAuthUser } from "react-auth-kit";
import React, { useCallback, useEffect, useState } from "react";
import styles from "./Dashboard.module.css";
import MyTask from "./components/MyTask/MyTask";
import call from "../../../assets/images/call.svg";
import meetings from "../../../assets/images/meet.svg";
import email from "../../../assets/images/mail.svg";
import demo from "../../../assets/images/demoIcon.svg";
import statusChange from "../../../assets/images/status.svg";
import created from "../../../assets/images/created.svg";
import payment from "../../../assets/images/rupee.svg";
import noteIcon from "../../../assets/images/noteIcon.svg";
import { useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import InactiveAccountPopup from "../../../components/CustomPopupBilling/InactiveAccountPopup";
import { useLocation } from "react-router";
import { TermsOfServices } from "../TermsOfServices/components/TermsOfServices";
import { PrivacyPolicy } from "../TermsOfServices/components/PrivacyPolicy";
import SalesPipelineOverview from "./components/SalesPipelineOverview/SalesPipelineOverview";
import DataTiles from "./components/DataTiles/DataTiles";
import RevenueAnalyticsGraph from "./components/RevenueAnalyticsGraph/RevenueAnalyticsGraph";
import LeadSourceData from "./components/LeadSourceData/LeadSourceData";
import StageVsExpectedRevenue from "./components/BarChart/StageVsExpectedRevenue";
import StageVsLeads from "./components/BarChart/StageVsLeads";
import StageVsLost from "./components/BarChart/StageVsLost";
import OverduePayments from "./components/OverduePayments/OverduePayments";
import ComingSoonBanner from "./components/ComingSoonBanner/ComingSoonBanner";
import getAccessStatus, {
  getSubDomainAccessStatus,
} from "../../../components/RolePermissionAccess/RolePermissionAccess";
import DashboardSkeleton from "../../../components/Skeletons/DashboardSkeleton";
import { GetBanner } from "./service/dashboard.request";
import { useDispatch } from "react-redux";
import { getBillingByInstituteId } from "../Manage/Billing/service/Billingslice";
import { GetBillingByInstituteId } from "../Manage/Billing/service/Billing.request";
import { formatRelativeTime } from "../../../components/Formatter/Formatter";
import moment from "moment";
import NurtureOSUpgradeBanner from "./components/NurtureOSUpgradeBanner/NurtureOSUpgradeBanner";

const style = {
  position: "absolute" as "absolute",
  bgcolor: "background.paper",
  border: "2px solid #fff",
  p: 2,
  top: "2%",
  left: "2%",
  right: "2%",
  bottom: "2%",
  overflow: "hidden",
  outline: "none",
};

type overdueData = {
  instituteId: any;
  branchId: any;
  limit: number;
  lastEvaluatedKey: string;
  lastEvaluatedSortKey: string;
};

export default function Dashboard(props: any) {
  const {
    dashboardDetails,
    dashboardData,
    termsAndConditionsLoading,
    termsAndConditionsSuccess,
    termsAndConditionsError,
    privacyPolicyLoading,
    privacyPolicySuccess,
    privacyPolicyError,
    AcceptTnC,
    AcceptPrivacyPolicy,
    setActiveInsitute,
    GetLeadListByInstituteAndContact,
    GetLeadSourceGraphData,
    GetRevenueAnalyticsGraphData,
    revenuGraphData,
    leadSourceGraphData,
    GetOverduePayments,
    overduePaymentsData,
    GetBranchList,
    GetStaffList,

    overduePaymentsloading,
    loading,
  } = props;
  const auth = useAuthUser();
  const user = auth();
  const location = useLocation();
  const isTabSize = useMediaQuery("(max-width:1100px)");
  const { userById } = useSelector((state: any) => state.userDetails);
  const [bannerMessage, setBannerMessage] = useState<any>("");
  const [billingInfo, setBillingInfo] = useState<any>();

  const hasAllBranchAccess = getSubDomainAccessStatus(
    "GLOBAL_PERMISSIONS",
    "BRANCH_ACCESS",
    "ALL_BRANCHES",
    userById?.rolePermission,
  );
  const salesPipelineAccess = getAccessStatus(
    "DASHBOARD",
    "SALES_PIPELINE_OVERVIEW",
    userById?.rolePermission,
  );
  const batchSlidesAccess = getAccessStatus(
    "DASHBOARD",
    "BATCH_SLIDES",
    userById?.rolePermission,
  );
  const revenueAnalyticsAccess = getAccessStatus(
    "DASHBOARD",
    "REVENUE_ANALYTICS_GRAPH",
    userById?.rolePermission,
  );
  const stageVsRevenueAccess = getAccessStatus(
    "DASHBOARD",
    "STAGE_VS_EXPECTED_REVENUE_GRAPH",
    userById?.rolePermission,
  );
  const overduePaymentAccess = getAccessStatus(
    "DASHBOARD",
    "OVERDUE_PAYMENTS",
    userById?.rolePermission,
  );
  const { taskStatusUpdateSuccess } = useSelector((state: any) => state.tasks);
  const branches = useSelector((state: any) => state.branch.branchList);
  const employees = useSelector((state: any) => state.staff.staffList);
  const { createPaymentSuccess } = useSelector((state: any) => state.nurture);

  const instituteData = JSON.parse(localStorage.getItem("ACTIVE_INSTITUTE")!);
  const accountStatus = instituteData?.billingStatus;

  const [selectedBranch, setSelectedBranch] = React.useState<any>("");
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [openPrivacy, setOpenPrivacy] = React.useState(false);
  const handleOpenPrivacy = () => setOpenPrivacy(true);
  const handleClosePrivacy = () => setOpenPrivacy(false);
  const [selectedCurrency, setSelectedCurrency] = React.useState("₹");
  const [showDaysLeft, setShowDaysLeft] = useState(true);

  const defaultBranch = branches
    ? branches?.find((branch: any) => branch.id === selectedBranch?.id)
    : "";

  useEffect(() => {
    if (!defaultBranch?.hasOwnProperty("currency")) {
      setSelectedCurrency("₹");
    } else if (defaultBranch?.currency === "") setSelectedCurrency("₹");
    else {
      setSelectedCurrency(defaultBranch?.currency);
    }
  }, [defaultBranch]);

  const sideIcon = (type: string) => {
    switch (type) {
      case "CALL":
        return call;
      case "MEETING":
        return meetings;
      case "EMAIL":
        return email;
      case "MAIL":
        return email;
      case "STATUS_CHANGE":
        return statusChange;
      case "DEMO":
        return demo;
      case "CREATED":
        return created;
      case "NOTE":
        return noteIcon;
      case "PAYMENT":
        return payment;
      default:
        return;
    }
  };

  const dashboardApiCall = useCallback(
    async (
      instituteId: string,
      userId: string,
      branchId: string,
    ): Promise<void> => {
      if (instituteId && userId && branchId) {
        const data = {
          instituteId: instituteId,
          userId: userId,
          branchId: branchId,
        };
        await dashboardData(data);
      }
    },
    [dashboardData],
  );

  const RevenueAnalyticsGraphApiCall = useCallback(
    async (
      instituteId: string,
      dateFilterValue: number,
      branchId: string,
    ): Promise<void> => {
      if (instituteId && dateFilterValue && branchId) {
        const data = {
          instituteId: instituteId,
          dateFilterType: "DAY",
          dateFilterValue: dateFilterValue,
          branchId: branchId,
        };
        await GetRevenueAnalyticsGraphData(data);
      }
    },
    [GetRevenueAnalyticsGraphData],
  );

  const LeadSourceGraphApiCall = useCallback(
    async (
      instituteId: string,
      dateFilterValue: number,
      branchId: string,
    ): Promise<void> => {
      if (instituteId && dateFilterValue && branchId) {
        const data = {
          instituteId: instituteId,
          dateFilterType: "DAY",
          dateFilterValue: dateFilterValue,
          branchId: branchId,
        };
        await GetLeadSourceGraphData(data);
      }
    },
    [GetLeadSourceGraphData],
  );

  const OverduePaymentApiCall = useCallback(
    async (instituteId: string, branchId: string): Promise<void> => {
      if (instituteId && branchId) {
        const data = {
          instituteId: instituteId,
          branchId: branchId,
          limit: 15,
          lastEvaluatedKey: "",
          lastEvaluatedSortKey: "",
        };
        await GetOverduePayments(data);
      }
    },
    [GetOverduePayments],
  );

  const onSelectBranchChange = React.useCallback(
    (event: object, value: any | null) => {
      const queryParams = new URLSearchParams(window.location.search);
      const revenueTimelineParam = queryParams.get("revenueAnalyticsTimeline");
      const leadSourceParam = queryParams.get("leadSourceTimeline");

      let revenueTimeline: any;
      let leadSourceTimeline: any;
      if (revenueTimelineParam) {
        revenueTimeline = parseInt(revenueTimelineParam);
      } else {
        revenueTimeline = 7;
      }
      if (leadSourceParam) {
        leadSourceTimeline = parseInt(leadSourceParam);
      } else {
        leadSourceTimeline = 7;
      }

      if (value !== null) {
        setSelectedBranch(value);
        queryParams.set("selectedBranch", value?.id);
        dashboardApiCall(
          user?.institute?.[0]?.instituteId,
          user?.institute?.[0]?.id,
          value?.id,
        );
        RevenueAnalyticsGraphApiCall(
          user?.institute?.[0]?.instituteId,
          revenueTimeline,
          value?.id,
        );
        LeadSourceGraphApiCall(
          user?.institute?.[0]?.instituteId,
          leadSourceTimeline,
          value?.id,
        );
        OverduePaymentApiCall(user?.institute?.[0]?.instituteId, value?.id);
      } else {
        setSelectedBranch("");
        queryParams.delete("selectedBranch");
      }
      const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
      window.history.pushState({}, "", newUrl);
    },
    [],
  );

  React.useEffect(() => {
    if (user !== null) {
      const instituteId = user?.institute[0]?.instituteId;
      if (instituteId) {
        // setActiveInsitute(instituteId);
      }
      let branchId: any;
      let revenueTimeline: any;
      let leadSourceTimeline: any;

      const queryParams = new URLSearchParams(window.location.search);
      const branchParam = queryParams.get("selectedBranch");
      const revenueTimelineParam = queryParams.get("revenueAnalyticsTimeline");
      const leadSourceParam = queryParams.get("leadSourceTimeline");

      if (branchParam) {
        branchId = branchParam;
      } else if (user?.institute?.[0]?.branchId) {
        branchId = user?.institute?.[0]?.branchId;
      } else {
        const loginTeamember = employees?.find(
          (item: any) => item?.email === user?.email,
        );
        if (loginTeamember) {
          branchId = loginTeamember?.branchId;
        }
      }
      if (revenueTimelineParam) {
        revenueTimeline = parseInt(revenueTimelineParam);
      } else {
        revenueTimeline = 7;
      }
      if (leadSourceParam) {
        leadSourceTimeline = parseInt(leadSourceParam);
      } else {
        leadSourceTimeline = 7;
      }
      if (branchId) {
        const fetchData = async () => {
          // await dashboardApiCall(
          //   instituteId,
          //   user?.institute?.[0]?.id,
          //   branchId
          // );

          // await RevenueAnalyticsGraphApiCall(
          //   instituteId,
          //   revenueTimeline,
          //   branchId
          // );

          // await LeadSourceGraphApiCall(
          //   instituteId,
          //   leadSourceTimeline,
          //   branchId
          // );

          // await OverduePaymentApiCall(instituteId, branchId);
          await dashboardData({
            instituteId: instituteId,
            userId: user?.institute?.[0]?.id,
            branchId: branchId,
          });
          if (revenueAnalyticsAccess) {
            await GetRevenueAnalyticsGraphData({
              instituteId: instituteId,
              dateFilterType: "DAY",
              dateFilterValue: revenueTimeline,
              branchId: branchId,
            });
          }

          await GetLeadSourceGraphData({
            instituteId: instituteId,
            dateFilterType: "DAY",
            dateFilterValue: leadSourceTimeline,
            branchId: branchId,
          });
          if (overduePaymentAccess) {
            await GetOverduePayments({
              instituteId: instituteId,
              branchId: branchId,
              limit: 15,
              lastEvaluatedKey: "",
              lastEvaluatedSortKey: "",
            });
          }
        };

        fetchData();
        // dashboardApiCall(instituteId, user?.institute?.[0]?.id, branchId);
        // RevenueAnalyticsGraphApiCall(instituteId, revenueTimeline, branchId);
        // LeadSourceGraphApiCall(instituteId, leadSourceTimeline, branchId);
        // OverduePaymentApiCall(instituteId, branchId);
      }
    }
  }, []);

  React.useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const branchParam = queryParams.get("selectedBranch");
    if (branchParam) {
      const branch = branches?.find((item: any) => item?.id === branchParam);
      if (branch) {
        setSelectedBranch(branch);
      }
    } else if (user?.institute?.[0]?.branchId) {
      const branch = branches?.find(
        (item: any) => item?.id === user?.institute?.[0]?.branchId,
      );
      if (branch) {
        setSelectedBranch(branch);
      }
    } else {
      const loginTeamember = employees?.find(
        (item: any) => item?.email === user?.email,
      );

      if (loginTeamember) {
        const branch = branches?.find(
          (item: any) => item?.id === loginTeamember?.branchId,
        );
        if (branch) {
          const instituteId = user?.institute[0]?.instituteId;
          setSelectedBranch(branch);
          dashboardApiCall(instituteId, user?.institute?.[0]?.id, branch?.id);
          RevenueAnalyticsGraphApiCall(instituteId, 7, branch?.id);
          LeadSourceGraphApiCall(instituteId, 7, branch?.id);
          OverduePaymentApiCall(instituteId, branch?.id);
        }
      }
    }
  }, [branches, employees]);

  useEffect(() => {
    if (
      location?.state?.isVersionMatching?.tnc === true &&
      location?.state?.isVersionMatching?.privacy === false
    ) {
      setOpen(false);
      setOpenPrivacy(true);
    } else if (
      location?.state?.isVersionMatching?.tnc === false &&
      location?.state?.isVersionMatching?.privacy === true
    ) {
      setOpen(true);
      setOpenPrivacy(false);
    } else if (
      location?.state?.isVersionMatching?.tnc === false &&
      location?.state?.isVersionMatching?.privacy === false
    ) {
      setOpen(true);
      setOpenPrivacy(true);
    } else {
      setOpen(false);
      setOpenPrivacy(false);
    }
  }, [location]);

  React.useEffect(() => {
    if (taskStatusUpdateSuccess !== true && taskStatusUpdateSuccess !== false) {
      if (user !== null) {
        let branchId: any;
        const queryParams = new URLSearchParams(window.location.search);
        const branchParam = queryParams.get("selectedBranch");
        if (branchParam) {
          branchId = branchParam;
        } else if (user?.institute?.[0]?.branchId) {
          branchId = user?.institute?.[0]?.branchId;
        } else {
          const loginTeamember = employees?.find(
            (item: any) => item?.email === user?.email,
          );
          if (loginTeamember) {
            branchId = loginTeamember?.branchId;
          }
        }
        if (branchId) {
          dashboardApiCall(
            user?.institute?.[0]?.instituteId,
            user?.institute?.[0]?.id,
            branchId,
          );
        }
      }
    }
  }, [taskStatusUpdateSuccess]);
  React.useEffect(() => {
    if (createPaymentSuccess !== true && createPaymentSuccess !== false) {
      if (user !== null) {
        let branchId: any;
        let revenueTimeline: any;

        const queryParams = new URLSearchParams(window.location.search);
        const branchParam = queryParams.get("selectedBranch");
        const revenueTimelineParam = queryParams.get(
          "revenueAnalyticsTimeline",
        );

        if (revenueTimelineParam) {
          revenueTimeline = parseInt(revenueTimelineParam);
        } else {
          revenueTimeline = 7;
        }
        if (branchParam) {
          branchId = branchParam;
        } else if (user?.institute?.[0]?.branchId) {
          branchId = user?.institute?.[0]?.branchId;
        } else {
          const loginTeamember = employees?.find(
            (item: any) => item?.email === user?.email,
          );
          if (loginTeamember) {
            branchId = loginTeamember?.branchId;
          }
        }
        if (branchId) {
          OverduePaymentApiCall(user?.institute?.[0]?.instituteId, branchId);
          RevenueAnalyticsGraphApiCall(
            user?.institute?.[0]?.instituteId,
            revenueTimeline,
            branchId,
          );
          dashboardApiCall(
            user?.institute?.[0]?.instituteId,
            user?.institute?.[0]?.id,
            branchId,
          );
        }
      }
    }
  }, [createPaymentSuccess]);

  const instituteDetail = useSelector(
    (state: any) => state.institute.instituteDetails,
  );

  const instituteBillingStatus =
    instituteDetail && instituteDetail.billingStatus;

  const isMigrated = instituteDetail?.isMigrated ?? instituteData?.isMigrated;

  React.useEffect(() => {
    GetBanner()
      .then((res: any) => {
        setBannerMessage(res?.data?.data);
      })
      .catch((err: any) => {});
    const data: any = {
      id: user?.institute?.[0]?.instituteId,
      status: accountStatus === "ARCHIVED" ? "DEACTIVATED" : "ACTIVE",
    };
    GetBillingByInstituteId(data)
      .then((d: any) => {
        setBillingInfo(d?.data?.data);
      })
      .catch((err: any) => {});
  }, []);

  const targetTimestamp = billingInfo?.[0]?.endDate; // given timestamp in ms
  const now = Date.now();

  const diffMs = targetTimestamp - now;
  const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

  const dueDate = billingInfo && billingInfo[0]?.startDate;
  const formattedDueDate = dueDate && moment(dueDate).format("DD MMM, YYYY");

  const dueDatePlus7Days = moment(formattedDueDate, "DD MMM, YYYY")?.add(
    7,
    "days",
  );

  const currentDate = moment();
  const lastDateOf7Days = dueDatePlus7Days?.clone()?.endOf("day"); // Assuming you want to consider the end of the day

  const remainingDaysInGracePeriod = lastDateOf7Days?.diff(currentDate, "days");

  let result;
  if (diffDays > 0) {
    result =
      billingInfo?.[0]?.instituteSubscriptionDetails?.billingStatus ===
      "GRACE_PERIOD"
        ? `${remainingDaysInGracePeriod} Days left`
        : `${diffDays} Days remain`;
  }

  return (
    <div
      style={{
        overflowY: "hidden",
        maxHeight: "calc(100vh - 65px)",
        minHeight: "calc(100vh - 65px)",
      }}
    >
      <InactiveAccountPopup type={accountStatus} />
      {dashboardDetails !== null && (
        <>{isMigrated ? <NurtureOSUpgradeBanner /> : <ComingSoonBanner />}</>
      )}

      {bannerMessage && bannerMessage?.length > 0 && (
        <div
          style={{
            backgroundColor: "rgba(17, 200, 155, 0.50)",
            overflow: "hidden",
            whiteSpace: "nowrap",
            width: "100%",
            height: "50px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          className="scroll-container"
        >
          <div
            className="scroll-text"
            dangerouslySetInnerHTML={{
              __html: bannerMessage[0]?.title,
            }}
          />
          <style>
            {`
      .scroll-text {
        display: inline-block;
        padding-left: 200%;
        animation: scroll 25s linear infinite;
        margin: 0;
        font-size: 16px;
        text-transform: capitalize;
        color: #142c44;
        font-weight: 500;
        cursor: pointer;
      }

      @keyframes scroll {
        0% { transform: translateX(0); }
        100% { transform: translateX(-100%); }
      }

      /* Pause when hovering over container */
      .scroll-container:hover .scroll-text {
        animation-play-state: paused;
      }
    `}
          </style>
        </div>
      )}

      <div className={styles.dashboardHeadWrap}>
        <div className={styles.dashboardHeadTitle}>Dashboard</div>

        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <div className={styles.dashboardHeadRight}>
            <div className={styles.dashboardHeadBranchFielLabel}>Branch</div>
            <div>
              {branches && (
                <Autocomplete
                  style={{
                    minWidth: "200PX",
                  }}
                  sx={{
                    "&& input": {
                      textTransform: "capitalize",
                      color: "#667085",
                      fontWeight: "500",
                    },
                  }}
                  disablePortal
                  disableClearable
                  disabled={hasAllBranchAccess ? false : true}
                  id="branchId"
                  options={branches}
                  getOptionLabel={(option: any) => option.branchName || ""}
                  fullWidth
                  onChange={onSelectBranchChange}
                  size="small"
                  value={defaultBranch || null}
                  PaperComponent={(props) => (
                    <Paper
                      sx={{
                        background: "#FFF",
                        border: "1px solid #E4E4E7",
                        fontFamily: "poppins",
                        fontSize: "10px",
                        textTransform: "capitalize",
                        color: "#142C44",
                        fontWeight: "400",
                        margin: "0",
                        boxShadow: "0px 2px 6px 0px rgba(0, 0, 0, 0.06)",
                      }}
                      {...props}
                    />
                  )}
                  renderInput={(params) => {
                    if (!defaultBranch) {
                      params.InputProps.endAdornment = null;
                    }
                    return <TextField variant="outlined" {...params} />;
                  }}
                />
              )}
            </div>
          </div>
          {billingInfo && diffDays > 0 && showDaysLeft && (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "flex-end",
                width: "80%",
                margin: "0px 20px",
              }}
            >
              <div
                style={{
                  border: "1px solid #E4E4E7",
                  padding: "8px",
                  borderRadius: "8px",
                  background: "rgba(255, 255, 255, 1)",
                  color:
                    billingInfo?.[0]?.instituteSubscriptionDetails
                      ?.billingStatus === "GRACE_PERIOD"
                      ? "rgb(250, 171, 16)"
                      : "#11C89B",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                {billingInfo?.[0]?.instituteSubscriptionDetails
                  ?.billingStatus === "GRACE_PERIOD"
                  ? `Grace Period - ${result}`
                  : `Active - ${result}`}
                <CloseIcon
                  sx={{ color: "red", cursor: "pointer" }}
                  onClick={() => {
                    setShowDaysLeft(false);
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </div>
      <div
        style={{
          overflowY:
            accountStatus === "ACTIVE" || accountStatus === "GRACE_PERIOD"
              ? "auto"
              : "hidden",
          maxHeight:
            diffDays > 0 && showDaysLeft === true
              ? "calc(100vh - 150px)"
              : "calc(100vh - 125px)",
          minHeight:
            diffDays > 0 && showDaysLeft === true
              ? "calc(100vh - 150px)"
              : "calc(100vh - 125px)",
          padding: "14px 20px",
        }}
      >
        <div
          style={{
            display: "flex",
            // justifyContent: "space-between",
            gap: isTabSize ? "10px" : "1%",
            marginBottom: isTabSize ? "10px" : "1%",
            flexDirection: isTabSize ? "column" : "row",
            flexWrap: "wrap",
          }}
        >
          <>
            {salesPipelineAccess && (
              <div
                style={{
                  width: isTabSize ? "100%" : "66.4%",
                  marginBottom: "10px",
                }}
              >
                {dashboardDetails === null ? (
                  <DashboardSkeleton />
                ) : (
                  <SalesPipelineOverview
                    salesData={dashboardDetails?.salesPipelineData}
                    selectedCurrency={selectedCurrency}
                  />
                )}
              </div>
            )}
            {batchSlidesAccess && (
              <div
                style={{
                  width: isTabSize ? "100%" : "32.6%",
                  marginBottom: "10px",
                }}
              >
                {dashboardDetails === null ? (
                  <DashboardSkeleton />
                ) : (
                  <DataTiles
                    batchSlideData={dashboardDetails?.batchSectionData}
                    selectedCurrency={selectedCurrency}
                  />
                )}
              </div>
            )}
          </>

          {revenueAnalyticsAccess && (
            <>
              <div
                style={{
                  width: isTabSize ? "100%" : "66.4%",
                  minHeight: "440px",
                  marginBottom: "10px",
                }}
              >
                {revenuGraphData === null ? (
                  <DashboardSkeleton />
                ) : (
                  <RevenueAnalyticsGraph
                    RevenueAnalyticsGraphApiCall={RevenueAnalyticsGraphApiCall}
                    revenuGraphData={revenuGraphData}
                    selectedCurrency={selectedCurrency}
                  />
                )}
              </div>
            </>
          )}
          <div
            style={{
              width: isTabSize ? "100%" : "32.6%",
              minHeight: "440px",
              marginBottom: "10px",
            }}
          >
            {leadSourceGraphData === null ? (
              <DashboardSkeleton />
            ) : (
              <LeadSourceData
                leadSourceData={leadSourceGraphData}
                LeadSourceGraphApiCall={LeadSourceGraphApiCall}
              />
            )}
          </div>

          {overduePaymentAccess && (
            <>
              <div
                style={{
                  width: isTabSize ? "100%" : "66.4%",
                  marginBottom: "10px",
                }}
              >
                {overduePaymentsData === null ? (
                  <DashboardSkeleton />
                ) : (
                  <OverduePayments
                    overduePaymentsData={overduePaymentsData}
                    selectedBranch={selectedBranch}
                    selectedCurrency={selectedCurrency}
                  />
                )}
              </div>
            </>
          )}

          <div
            style={{
              width: isTabSize ? "100%" : "32.6%",
              marginBottom: "10px",
            }}
          >
            {dashboardDetails === null ? (
              <DashboardSkeleton />
            ) : (
              <MyTask
                data={dashboardDetails?.myTaskData?.myTaskData}
                sideIcon={sideIcon}
                GetLeadListByInstituteAndContact={
                  GetLeadListByInstituteAndContact
                }
              />
            )}
          </div>
          {/* {stageVsRevenueAccess && (
            <div
              style={{
                width: isTabSize ? "100%" : isTabSize ? "100%" : "32.6%",
                marginBottom: "10px",
              }}
            >
              {dashboardDetails === null ? (
                <DashboardSkeleton />
              ) : (
                <StageVsExpectedRevenue
                  labels={
                    dashboardDetails?.stageGraphData?.revenueGraphData?.labels
                  }
                  data={
                    dashboardDetails?.stageGraphData?.revenueGraphData?.datasets
                  }
                  yMaxValue={
                    dashboardDetails?.stageGraphData?.revenueGraphData
                      ?.yMaxValue
                  }
                />
              )}
            </div>
          )} */}

          {/* <div
            style={{
              width: isTabSize ? "100%" : "32.6%",
              marginBottom: "10px",
            }}
          >
            {dashboardDetails === null ? (
              <DashboardSkeleton />
            ) : (
              <StageVsLeads
                labels={
                  dashboardDetails?.stageGraphData?.activeLeadGraphData?.labels
                }
                data={
                  dashboardDetails?.stageGraphData?.activeLeadGraphData
                    ?.datasets
                }
                yMaxValue={
                  dashboardDetails?.stageGraphData?.activeLeadGraphData
                    ?.yMaxValue
                }
              />
            )}
          </div>
          <div
            style={{
              width: isTabSize ? "100%" : "32.6%",
              marginBottom: "10px",
            }}
          >
            {dashboardDetails === null ? (
              <DashboardSkeleton />
            ) : (
              <StageVsLost
                labels={
                  dashboardDetails?.stageGraphData?.lostLeadGraphData?.labels
                }
                data={
                  dashboardDetails?.stageGraphData?.lostLeadGraphData?.datasets
                }
                yMaxValue={
                  dashboardDetails?.stageGraphData?.lostLeadGraphData?.yMaxValue
                }
              />
            )}
          </div> */}
        </div>
      </div>

      <Modal open={false} onClose={handleClosePrivacy}>
        <Box sx={style}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            {location?.state?.isVersionMatching?.privacy === true && (
              <button
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                }}
                onClick={handleClosePrivacy}
              >
                <CloseIcon />
              </button>
            )}
          </div>
          <PrivacyPolicy
            tnc={location?.state?.tnc}
            isVersionMatching={location?.state?.isVersionMatching}
            privacyPolicyLoading={privacyPolicyLoading}
            privacyPolicySuccess={privacyPolicySuccess}
            privacyPolicyError={privacyPolicyError}
            AcceptPrivacyPolicy={AcceptPrivacyPolicy}
            setOpenPrivacy={setOpenPrivacy}
          />
        </Box>
      </Modal>
      <Modal open={false} onClose={handleClose}>
        <Box sx={style}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            {location?.state?.isVersionMatching?.tnc === true && (
              <button
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                }}
                onClick={handleClose}
              >
                <CloseIcon />
              </button>
            )}
          </div>
          <TermsOfServices
            tnc={location?.state?.tnc}
            isVersionMatching={location?.state?.isVersionMatching}
            termsAndConditionsLoading={termsAndConditionsLoading}
            termsAndConditionsSuccess={termsAndConditionsSuccess}
            termsAndConditionsError={termsAndConditionsError}
            AcceptTnC={AcceptTnC}
            setOpen={setOpen}
          />
        </Box>
      </Modal>
    </div>
  );
}
